import ApiClient from "./repository";
import authstore from '@/store/modules/auth';
import {clients} from '@/services/client.factory'

export default {
    async getTree() {
        let data = await clients.placeServiceClient.getCategoryTree(55)
        return {
            list: data.data,
            totalItems: data.count
        };

    }
};